/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featurehistorydescription2Inputs */

const he_extension_featurehistorydescription2 = /** @type {(inputs: Extension_Featurehistorydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גישה להיסטוריית מחירים מלאה מאז כניסת המוצר למלאי`)
};

const en_extension_featurehistorydescription2 = /** @type {(inputs: Extension_Featurehistorydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access full price history since the product was first stocked`)
};

/**
* | output |
* | --- |
* | "Access full price history since the product was first stocked" |
*
* @param {Extension_Featurehistorydescription2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featurehistorydescription2 = /** @type {((inputs?: Extension_Featurehistorydescription2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featurehistorydescription2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featurehistorydescription2(inputs)
	return en_extension_featurehistorydescription2(inputs)
});
export { extension_featurehistorydescription2 as "extension_featureHistoryDescription" }